export default __webpack_public_path__ + "static/media/game.dde2ddef.mp3";